"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * TabVisibilityMonitor is a React component that monitors the visibility of the tab.
 * When the user returns on the tab after being hidden for a specified duration,
 * it triggers a callback function.
 */
var TabVisibilityMonitor = function TabVisibilityMonitor(_ref) {
  var onReturn = _ref.onReturn,
    _ref$timeThresholdMs = _ref.timeThresholdMs,
    timeThresholdMs = _ref$timeThresholdMs === void 0 ? 60000 : _ref$timeThresholdMs,
    _ref$getCurrentTime = _ref.getCurrentTime,
    getCurrentTime = _ref$getCurrentTime === void 0 ? function () {
      return Date.now();
    } : _ref$getCurrentTime;
  var hasNotifiedRef = (0, _react.useRef)(false);
  var lastTimeVisibleRef = (0, _react.useRef)(getCurrentTime());
  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.hidden) {
      lastTimeVisibleRef.current = getCurrentTime();
    } else {
      var currentTime = getCurrentTime();
      var timeElapsed = currentTime - lastTimeVisibleRef.current;
      if (timeElapsed >= timeThresholdMs && !hasNotifiedRef.current) {
        onReturn();
        hasNotifiedRef.current = true;
      }
    }
  };
  (0, _react.useEffect)(function () {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return null;
};
TabVisibilityMonitor.propTypes = {
  /** Function to call when the user returns to the tab after the specified time threshold */
  onReturn: _propTypes["default"].func.isRequired,
  /** Minimum time (in milliseconds) that the tab needs to be hidden before triggering onReturn */
  timeThresholdMs: _propTypes["default"].number,
  /** Function that returns the current time in milliseconds */
  getCurrentTime: _propTypes["default"].func
};
var _default = exports["default"] = TabVisibilityMonitor;